import ArticlesBannerA from '@components/BannerAds/ArticlesBannerA';
import ArticlesFooterArticle from '@components/BannerAds/ArticlesFooterArticle';
import BrokersWithLicense from '@components/BrokerList/BrokerWithLicense';
import MiddleBanner from '@components/HeaderBanner/MiddleBanner';
import { useModal } from '@components/ModalHook';
import { MODAL_ID as POPUP_ACADEMY_EBOOK } from '@components/popup/PopupAcademyEbook';
import RichTextWPViewer from '@components/RichTextWPViewer';
// import ShortToc from '@components/TableContent/ShortToc';
import VnrLink from '@components/VnrLink';
import { getInfoUserMetaOfUsers } from '@services/userMeta.service.js';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { USER_MEATA_KEY } from 'src/constants';
import useLessonSeenState from 'src/hook/useLessonSeenState';

import postStyles from '../../../public/css/CommonPost.module.scss';
import styles from './PostDetail.module.scss';
import PostDetailScriptDom from './PostDetailScriptDom';
import PostDirectionalLink from './PostDirectionalLink';
import { getConfig } from '@services/story.service';

//dynamic import
const ArticlesInsideArticle = dynamic(() => import('@components/BannerAds/ArticlesInsideArticle'), {
  ssr: false,
});
const LPDirectionalBanner = dynamic(() => import('./LPDirectionalBanner'), {
  ssr: false,
});
const PopupZoomImage = dynamic(() => import('@components/popup/PopupZoomImage'), {
  ssr: false,
});
const PopupAcademyEbook = dynamic(() => import('@components/popup/PopupAcademyEbook'), {
  ssr: false,
});
const Sticky = dynamic(() => import('react-stickynode'));

const PostDetail = ({
  post,
  postAuthor,
  acfOptions,
  isEnableSaveSeenState = false,
  isPreview = false,
  isHaveDownloadEbookButton,
  newForexBroker,
  isAETOSPost
}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.app.user);
  const [userMetaData, setUserMetaData] = useState([]);
  const [isClickDownloadEbook, setIsClickDownloadEbook] = useState(false);
  const [isEligibleToDownloadEbook, setIsEligibleToDownloadEbook] = useState(false);
  const [, showModalAcademyEbook] = useModal(POPUP_ACADEMY_EBOOK);
  const { date, excerpt, title, content, categories } = post;

  const countWords = (str) => {
    if (!str) return 0;
    str = str.replace(/(^\s*)|(\s*$)/gi, '');
    str = str.replace(/[ ]{2,}/gi, ' ');
    str = str.replace(/\n /, '\n');
    return str.split(' ').length;
  };
  const readingTime = Math.floor(countWords(content?.rendered) / 200);
  const publicDate = new Date(date);
  const formatDate = new Intl.DateTimeFormat('ru-RU', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(publicDate);

  const { saveLessonSeenState } = useLessonSeenState();

  const percentageSeen = () => {
    const element = document.getElementById('postContentContainer');
    if (!element) {
      return 0;
    }
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY;
    const elementOffsetTop = element.offsetTop;
    const elementHeight = element.offsetHeight;

    // Calculate percentage of the element that's been seen
    const distance = scrollTop + viewportHeight - elementOffsetTop;
    const percentage = Math.round(distance / (elementHeight / 100));

    // Restrict the range to between 0 and 100\
    return Math.min(100, Math.max(0, percentage));
  };

  function saveSeenPercentage() {
    saveLessonSeenState(post.id, percentageSeen());
  }

  const registerSaveViewingState = () => {
    window.addEventListener('scroll', saveSeenPercentage);
  };

  const handleClickEbookLink = async () => {
    setIsClickDownloadEbook(true);
    if (!currentUser?.id) {
      dispatch.app.showPopupLogin({ positionLogin: 'POST_INTRODUCE_ACADEMY_EBOOK' });
      return;
    }

    if (userMetaData.length !== 3) {
      setIsEligibleToDownloadEbook(false);
      showModalAcademyEbook({
        isShow: true,
        content: userMetaData,
      });
    }
    setIsClickDownloadEbook(false);

    return;
  };

  const getUserMetaData = async () => {
    const res = await getInfoUserMetaOfUsers({
      userIds: [currentUser?.id],
      metaKeys: [
        USER_MEATA_KEY.IS_SUBCRIBED_TELEGRAM_CHANNEL,
        USER_MEATA_KEY.IS_SUBCRIBED_TELEGRAM_GROUPCHAT,
        USER_MEATA_KEY.IS_SUBCRIBED_YOUTUBE,
      ],
    });

    if (res?.data?.content) {
      setUserMetaData(res?.data?.content);
    }

    if (res?.data?.content?.length === 3) {
      setIsEligibleToDownloadEbook(true);
    } else {
      if (isClickDownloadEbook) {
        showModalAcademyEbook({
          isShow: true,
        });
        setIsClickDownloadEbook(false);
      }
    }
  };
  let isHideBannerA = post?.categories?.some((item) => [4, 3391].includes(item)) || isAETOSPost;

  useEffect(() => {
    if (!isHaveDownloadEbookButton || !currentUser?.id) {
      setIsEligibleToDownloadEbook(false);

      return;
    }

    getUserMetaData();
  }, [currentUser, isHaveDownloadEbookButton]);

  useEffect(() => {
    if (isEnableSaveSeenState) {
      registerSaveViewingState();
    }
    return () => {
      if (isEnableSaveSeenState) {
        window.removeEventListener('scroll', saveSeenPercentage);
      }
    };
  }, [post.id]);

  return (
    <div id="vnrPostDetail" className={styles.vnrPostDetail}>
      <h1
        dangerouslySetInnerHTML={{ __html: `${title.rendered}` }}
        className={postStyles.postTitle}
      ></h1>
      <div className={styles.detail}>
        <span className={styles.postTime}>{formatDate} </span>
        {postAuthor && (
          <span className={postStyles.postAuthor}>
            &#8226; <VnrLink to={`/tac-gia/${postAuthor.slug}`}>{postAuthor.name}</VnrLink>
          </span>
        )}
        <span className={postStyles.readingTime}> &#8226; {readingTime} phút đọc</span>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: `${excerpt.rendered}` }}
        className={postStyles.postExcerpt}
      ></div>

      {/* <ShortToc tableOfContent={tableOfContent} /> */}
      {!isHideBannerA && (
        <div className={styles.articlesBannerA}>
          <ArticlesBannerA />
        </div>
      )}

      <div id="postContentContainer">
        <RichTextWPViewer
          content={content.rendered}
          className={postStyles.postContent}
        ></RichTextWPViewer>
        <div id="articles_inside_article_wrapper">
          <Sticky top={48} bottomBoundary="#postContentContainer">
            <ArticlesInsideArticle />
          </Sticky>
          <div id="contentAfterBannerInsideArticle"></div>
        </div>

        <div style={{ display: 'none' }}>
          <LPDirectionalBanner id="configHeading2No2" />
        </div>
      </div>

      {isMobile && <>
        <BrokersWithLicense brokerList={newForexBroker} />
        <MiddleBanner isCustom />
      </>}

      {!isPreview && <PostDetailScriptDom acfOptions={acfOptions} />}
      {!isPreview && <PostDirectionalLink categories={categories} />}
      {isHaveDownloadEbookButton && !isEligibleToDownloadEbook && (
        <div onClick={() => handleClickEbookLink()} className={styles.btnAcademyEbook}>
          TẢI EBOOK “VNREBATES – PRICE ACTION CHUYÊN SÂU.PDF” MIỄN PHÍ
        </div>
      )}

      {isEligibleToDownloadEbook && (
        <div className={styles.linkEbook}>
          <VnrLink to="https://agileops-gafv-dev-videos.s3.amazonaws.com/VnRebates - Price Action chuyên sâu.pdf">
            &#187; Tải Ebook " VnRebates - Price Action chuyên sâu.PDF" &#171;
          </VnrLink>
        </div>
      )}

      <PopupZoomImage />
      <PopupAcademyEbook
        userId={currentUser?.id}
        setIsEligibleToDownloadEbook={setIsEligibleToDownloadEbook}
      />
    </div>
  );
};

export default PostDetail;
